import Footer from "../components/footer";
import Header from "../components/header"
import SideNav from "../components/sidenav"
import PageHeader from "../components/pageHeader";
import React, { useEffect, useState, useRef } from "react";
import {NavLink, useNavigate, useParams } from "react-router-dom";

import EditorComponent from "../../../component/editorComponent"; // Import the centralized CKEditor component

const AddSubject = ()=>{

    let userInfo = JSON.parse(localStorage.getItem('admin-info'));
    const { id } = useParams();
    const navigate = useNavigate();
    const editorRef = useRef(); // Ref to store the CKEditor instance
    const [subject, setSubject] = useState("");
    const [newdata, setNewdata] = useState({
        subject: '', description: ''
    });

    // Function to Fetch data from API for dropdown
    const fetchData = async (url, setData) => {
        debugger;
        try {
            const response = await fetch(url);
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }

    };

    // Modified useEffect for data fetching
    useEffect(() => {
        if (id) {
            fetchData('https://igapi.heuristticminds.com/api/SubjectStyleList/Get-GetSubjectDetailsToEditByID?id=' + id, (data) => {
                const subjectData = data[0];
                setNewdata({
                    subject: subjectData.subject,
                    description: subjectData.description,
                });
                setSubject(subjectData.subject); // Also set the title state
                if (editorRef.current) {
                    editorRef.current.setData(subjectData.description);
                }
            });
        }
    }, [id]);

    const handleSubjectChange = (event) => {
        const newSubject = event.target.value;
            setSubject(newSubject);
            setNewdata(prevData => ({
            ...prevData,
            subject: newSubject // Update newdata.subject whenever the Subject changes
    }));
    };

    const handleDescriptionEditorChange = (event, editor) => {
        const data = editor.getData();
        setNewdata(prevData => ({
            ...prevData,
            description: data
        }));
    };

    // Capture the CKEditor instance once it's ready
    const handleEditorReady = (editor) => {
        editorRef.current = editor;
    };

    const handleUpdate = async () => {
        // Check if both title and policyDetails are not empty
        if (subject.trim() === '' || newdata.description.trim() === '') {
            alert('Please fill in all fields.'); // You can replace this with a more sophisticated validation message
            return; // Prevent form submission if validation fails
        }
        const formData = {
            "id":id,
            "subject": subject,
            "description": newdata.description
        };

        try {
            // Make the API call to save the form data
            const response = await fetch('https://igapi.heuristticminds.com/api/SubjectStyleList/Update-UpdateSubjectDetails', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });
            if (response.ok) {

                setSubject(''); // Clear the title input Box
                // Clear CKEditor content using the API
                if (editorRef.current) {
                    editorRef.current.setData(''); // This clears the editor content
                }
                const confirmed = window.confirm("Subject and Description Updated Successfully !!!");
                
                navigate(`/subject/`);

            } else {
                // Handle error cases
                console.error('Error saving form data:', response.statusText);
            }
        } catch (error) {

            console.error('Error saving form data:', error);
        }
    };

    const handleSubmit = async () =>{

        // Check if both Subject and Description are not empty
        if (subject.trim() === '' || newdata.description.trim() === '') {
            alert('Please fill in all fields.'); // You can replace this with a more sophisticated validation message
            return; // Prevent form submission if validation fails
        }
        const formData = {

            "subject": subject,
            "description": newdata.description,
            "createdBy": userInfo.user_id
        };
        try {
            // Make the API call to save the form data
            const response = await fetch('https://igapi.heuristticminds.com/api/SubjectStyleList/Add-SaveSubjectDetailList', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });
            if (response.ok) {
                
                setSubject(''); // Clear the title input Box
                // Clear CKEditor content using the API
                if (editorRef.current) {
                    editorRef.current.setData(''); // This clears the editor content
                }
                const confirmed = window.confirm("Subject and  Description Saved Successfully !!!, Add another Subject ? ");
                if (!confirmed) {
                    navigate(`/subject/`);
                    return; // If not confirmed, return early without deleting
                    
                }
                

            } else {
                // Handle error cases
                console.error('Error saving form data:', response.statusText);
            }
        } catch (error) {
            console.error('Error saving form data:', error);
        }

    };

    return(
        <>
        <Header />
            <div id="layoutSidenav">
                <SideNav />
                <div id="layoutSidenav_content">

                    <PageHeader name={id > 0 ? "Edit Subject and Description" : "Add Subject and Description"} icon='bi bi-activity' />
                    <div className="container-xl px-4">
                        <div className="row">
                            <div className="col-lg-12 mb-4">
                                <div className="card mb-4 vh-100">
                                    <div className="card-header">Subject and Description</div>
                                    <div className="card-body">
                                        <NavLink className="btn btn-primary float-end" to={'/subject'}><i className="bi bi-arrow-return-left"></i> Back</NavLink>
                                        <div className="clearfix"></div>
                                        <div className="p-4 pt-2">

                                            <div className="row">
                                                <div className="col-sm-6 form-group mb-3">
                                                    <label>Subject <span style={{ color: "#ff0000" }}>*</span></label>
                                                    <input type="text"
                                                        name="subject"
                                                        value={subject}
                                                        className="form-control"
                                                        maxLength={45}
                                                        placeholder="Subject"
                                                        onChange={handleSubjectChange} />
                                                </div>
                                                </div>
                                                <div className="row">
                                                <div className="col-sm-12 form-group mb-3">
                                                    <label>Description <span style={{ color: "#ff0000" }}>*</span></label>
                                                    <EditorComponent
                                                            isAdvanced={true} // Set to true for advanced editor with image upload
                                                            data={newdata.description} // Initial data for the editor
                                                            onReady={handleEditorReady} // Capture the editor instance
                                                            onChange={handleDescriptionEditorChange}
                                                            placeholder="Enter Details / Description"

                                                        />
                                                </div>
                                            </div>
                                            
                                               
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6 form-group mt-3">
                                                {/*<button type="button" onClick={handleSubmit} className="btn btn-primary w-50">Submit</button>*/}
                                                {id>0 ?
                                                            <button type="button" onClick={handleUpdate} className="btn btn-primary w-50">Update</button>
                                                            :
                                                            <button type="submit"
                                                            onClick={handleSubmit}
                                                                className="btn btn-primary w-50">Submit</button>
                                                        }

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                    <Footer />
                </div>                
            </div>
        </>
    )
};
export default AddSubject
